import { useState } from 'react';
import { Navigate, useLocation, type Location } from 'react-router';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useUrlParam } from '#hooks/useUrlParam.ts';
import { DeletionSuccess } from '#screens/deleted-account/DeletionSuccess.tsx';
import { FeedbackSuccess } from './FeedbackSuccess.tsx';
import { DeletedAccountForm } from './form/DeletedAccountForm.tsx';
import type { DeletedAccountState } from './types.ts';

export function DeletedAccountPage() {
  const [email] = useUrlParam('email');
  const [submittedFeedback, setSubmittedFeedback] = useState(false);
  const { getAuthState, signout } = useAuth();
  const location = useLocation() as Location<DeletedAccountState>;

  // If the user's logged in, don't show this page
  if (getAuthState() !== 'unauthenticated') {
    // If we are signed in and coming from just deleting the account, sign out
    if (location.state?.accountDeleted) {
      void signout();
    } else {
      // Otherwise, getouttahere
      return <Navigate to="/" replace={true} />;
    }
  }

  if (submittedFeedback) {
    return <FeedbackSuccess />;
  }

  if (email) {
    return (
      <DeletedAccountForm
        email={email}
        onSubmitted={() => {
          setSubmittedFeedback(true);
        }}
      />
    );
  }

  return <DeletionSuccess />;
}
